import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SdvorGenericLinkComponent } from '../../components';
import { SdvorSharedCmsComponents } from '../cms-components.enum';
import { CustomLinkComponent } from './custom-link.component';

@NgModule({
  declarations: [CustomLinkComponent],
  imports: [
    NgIf,
    AsyncPipe,
    MediaModule,
    SdvorGenericLinkComponent,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [SdvorSharedCmsComponents.CMSLinkComponent]: {
          component: CustomLinkComponent,
        },
      },
    }),
  ],
  exports: [CustomLinkComponent],
})
export class CustomLinkLazyModule {}
